/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Thisishowyourlistingwillappeartousers8Inputs */

const en_thisishowyourlistingwillappeartousers8 = /** @type {(inputs: Thisishowyourlistingwillappeartousers8Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`This is how your listing will appear to users`)
};

const de_thisishowyourlistingwillappeartousers8 = /** @type {(inputs: Thisishowyourlistingwillappeartousers8Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`So sehen andere deinen Ort.`)
};

/**
* | output |
* | --- |
* | "This is how your listing will appear to users" |
*
* @param {Thisishowyourlistingwillappeartousers8Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const thisishowyourlistingwillappeartousers8 = /** @type {((inputs?: Thisishowyourlistingwillappeartousers8Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Thisishowyourlistingwillappeartousers8Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_thisishowyourlistingwillappeartousers8(inputs)
	return de_thisishowyourlistingwillappeartousers8(inputs)
});
export { thisishowyourlistingwillappeartousers8 as "thisIsHowYourListingWillAppearToUsers" }